module.exports = __webpack_public_path__ + "img/M0090.a189ad41.png";